
import Titlebar from '@/ui/components/Titlebar.vue';
import SettingsModal from '@/ui/components/modals/SettingsModal.vue';
import * as Games from '../../domain/Games';
import { ui } from '../../domain/ui';
import { requestGetter } from '../../utils/cef';
import { defineComponent } from 'vue';

const REFRESH_INTERVAL_MS = 180000;

export default defineComponent({
  name: 'DefaultLayout',
  components: {
    Titlebar,
    SettingsModal,
  },
  data() {
    return {
      settingsModalIsOpen: false,
      settingsModalDefaultTab: '',
      refreshTimer: 0 as any,
    };
  },
  computed: {
    settingsToken(): number {
      return ui.settings.token;
    },
  },
  watch: {
    settingsToken() {
      this.openSettingsModal(ui.settings.tab);
    },
  },
  mounted() {
    this.refreshTimer = setInterval(this.pollGames, REFRESH_INTERVAL_MS);
  },
  beforeUnmount() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer);
    }
  },
    methods: {
    openSettingsModal(val:any) {
      // Re-open cleanly even if the modal is already up, so the requested tab (and its auto-run)
      // is applied by the modal's open watcher.
      if (this.settingsModalIsOpen) {
        this.settingsModalIsOpen = false;
        this.$nextTick(() => {
          this.settingsModalDefaultTab = val;
          this.settingsModalIsOpen = true;
        });
        return;
      }
      this.settingsModalDefaultTab = val;
      this.settingsModalIsOpen = true;
    },
    pollGames() {
      requestGetter("IS_LOGGED", {}, (logdata: any) => {
        if (logdata.status !== 200) {
          return;
        }
        requestGetter("GET_TOKEN", {}, (ttdata: any) => {
          if (ttdata.status === 200 && ttdata.payload && ttdata.payload.jwt) {
            Games.refreshGames(ttdata.payload.jwt).catch(() => undefined);
          }
        });
      });
    }
  }
});
